<style lang="scss">
.zoezi-workout-book-user-row {
    .booked {
        background: #ded;
    }

    .queued {
        background:#fed;
    }
}
</style>

<template>
    <div class="zoezi-workout-book-user-row">
        <div :class="{booked: booked}" class="d-flex pa-2" v-if="state == 'cancel'">
            <v-avatar size="20" class="mr-1">
                <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
            </v-avatar>
            <div v-if="bookedViaCourse" class="flex-grow-1">{{ bookedText + ' ' + $translate('via course' )}}</div>
            <div v-else class="flex-grow-1">{{bookedText}}</div>
            <v-btn v-if="workout.unbookable()" color="error" style="height: 22px" text class="zoezi-button-thin" @click.stop="cancel" :loading="cancelling">{{$translate('CANCEL_BOOKING')}}</v-btn>
            <v-btn v-else disabled style="height: 22px" text class="zoezi-button-thin">{{$translate('Can not cancel booking')}}</v-btn>
        </div>

        <div :class="{booked: booked}" class="d-flex pa-2" v-else-if="state == 'book'">
            <v-avatar size="20" class="mr-1">
                <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
            </v-avatar>
            <div class="flex-grow-1">{{ $translate('Book') + ' ' + name2}}</div><v-btn color="primary" style="height: 22px" text class="zoezi-button-thin" @click.stop="book" :loading="booking">{{$translate('Book')}}</v-btn>
        </div>

        <div :class="{booked: booked, queued: queued}" class="d-flex pa-2" v-else-if="state == 'leavequeue'">
            <v-avatar size="20" class="mr-1">
                <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
            </v-avatar>
            <div v-if="!workout.firstCome()" class="flex-grow-1">{{$translate('{0} is in queue position {1}').format(name, workout.getQueuePosition(user))}}</div>
            <div v-else class="flex-grow-1">{{name + ' ' + $translate('watching, first come, first served applies to the workout')}}</div>
            <v-btn color="error" style="height: 22px; float:right" text class="zoezi-button-thin" @click.stop="cancel" :loading="cancelling">{{$translate('Leave the queue')}}</v-btn>
        </div>

        <div :class="{booked: booked}" class="d-flex pa-2" v-else-if="state == 'queue'">
            <v-avatar size="20" class="mr-1">
                <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
            </v-avatar>
            <div class="flex-grow-1">{{$translate('Put {0} in queue').format(name2)}}</div><v-btn color="primary" style="height: 22px" text class="zoezi-button-thin" @click.stop="queue" :loading="booking">{{$translate('Queue up')}}</v-btn>
        </div>

        <div :class="{booked: booked}" class="d-flex pa-2 flex-column" v-else-if="state == 'nobook'">
            <div class="d-flex flex-row">
                <v-avatar size="20" class="mr-1">
                    <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
                </v-avatar>
                <div class="flex-grow-1">{{name + ' ' + $translate('can not book')}}</div>
            </div>
            <div>
                <div class="ml-6 text--secondary" v-for="reason in noobookReasons" :key="reason" v-text="reason" />
            </div>
        </div>

        <div :class="{booked: booked}" class="d-flex pa-2" v-else-if="state == 'bookbuy' || state == 'queuebuy'">
            <v-avatar size="20" class="mr-1">
                <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
            </v-avatar>
            <div class="flex-grow-1">{{name + ' ' + $translate('does not have a trainingcard')}}</div>
        </div>

        <div class="d-flex pa-2 text--secondary" v-else-if="state == 'cancelled'">
            <v-avatar size="20" class="mr-1">
                <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
            </v-avatar>
            <template v-if="workout.isInQueue(user)"><div class="flex-grow-1">{{$translate('{0} was in queue position {1}').format(name, workout.getQueuePosition(user))}}</div><v-btn disabled color="error" style="height: 22px" text class="zoezi-button-thin" @click.stop="cancel" :loading="cancelling">{{$translate('Leave queue')}}</v-btn></template>
            <template v-else-if="workout.isBooked(user)"><div class="flex-grow-1">{{name + ' ' + $translate('was booked')}}</div><v-btn disabled color="error" style="height: 22px" text class="zoezi-button-thin" @click.stop="cancel" :loading="cancelling">{{$translate('CANCEL_BOOKING')}}</v-btn></template>
            <template v-else>{{name + ' ' + $translate('was not booked')}}</template>
        </div>

        <div v-else class="d-flex pa-2">
            <v-avatar size="20" class="mr-1">
                <img :src="this.$api.getImageUrl(user.imagekey || '/assets/img/profile_avatar_man.jpg', 200)" />
            </v-avatar>
            <div class="flex-grow-1">{{name}}</div>
            State: {{state}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-workout-book-user-row',

    props: {
        workout: {
            type: Object
        },
        user: {
            type: Object
        }
    },

    data: () => ({
        cancelling: false,
        booking: false
    }),

    watch: {
        '$store.state.bookings'(bookings) {
            if (bookings) {
                let wbookings = bookings?.workouts?.filter(w => w.id == this.workout?.id);
                let has_booking = wbookings.find(wb => wb.user_id == this.user.id);

                if (this.booking && has_booking) {
                    this.booking = false;
                }

                if (this.cancelling && !has_booking) {
                    this.cancelling = false;
                }
            }
        }
    },

    computed: {
        booked() {
            return this.workout.isBooked(this.user);
        },
        bookedText() {
            if (this.user.id == this.$store.state.user.id) {
                return this.$translate('You are booked')
            } else {
                return this.$translate('{0} is booked').format(this.user.name.split(' ')[0]);
            }
        },
        queued() {
            return this.workout.isInQueue(this.user);
        },
        name() {
            return this.user.id == this.$store.state.user.id ? 'Du' : this.user.name.split(' ')[0];
        },
        name2() {
            return this.user.id == this.$store.state.user.id ? 'mig' : this.user.name.split(' ')[0];
        },
        bookedViaCourse() {
            return this.$store.state.bookings.workouts.find(w => w.id == this.workout.id && w.user_id == this.user.id).is_booked_via_course;
        },
        state() {
            return this.workout.getState(this.user);
        },
        noobookReasons() {
            return this.workout.getNoBookReasons(this.user);
        }
    },

    methods: {
        cancel() {
            var cancelText = this.workout.workoutType.name + " " + Date.formatTimeRelative(this.workout.startTime);
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('CANCEL_BOOKING'),
                text: this.$translate('Are you sure you want to cancel {0}?').format(cancelText),
                actionText: this.$translate('CANCEL_BOOKING'),
                action: () => {
                    this.cancelling = true;
                    this.workout.cancel(this.user, () => this.cancelling = false)
                }
            });
        },
        book() {
            this.booking = true;
            this.workout.book(this.user, () => this.booking = false);
        },
        queue() {
            this.booking = true;
            this.workout.book(this.user, () => this.booking = false);
        }
    }
}
</script>
